import { Component, input, OnInit } from '@angular/core';
import { BaseViewComponent, SectionHeaderSize } from '@sb/library/base';

@Component({
    selector: 'lib-section-header',
    templateUrl: './section-header.component.html',
    styleUrls: ['./section-header.component.scss'],
    host: {
        style: 'display: contents'
    }
})
export class SectionHeaderComponent extends BaseViewComponent implements OnInit {
    size = input<SectionHeaderSize>(SectionHeaderSize.Medium);
    showDivider = input<boolean>(false);
}
